import { lt } from '@mews/framework';
import { IconName, Tag } from '@optimus-web/core';
import { ContractTemplateStatus } from '@mews-commander/data-access';

interface TemplateStatusCellProps {
    status: ContractTemplateStatus;
}

export const TemplateStatusCell = ({ status }: TemplateStatusCellProps) => {
    switch (status) {
        case ContractTemplateStatus.UpToDate:
            return (
                <Tag variant="success" leadingIcon={IconName.Done}>
                    {lt('ContractTemplateUpToDateLabel')}
                </Tag>
            );
        case ContractTemplateStatus.TemplateUnavailable:
            return (
                <Tag variant="warning" leadingIcon={IconName.Info}>
                    {lt('ContractTemplateModifiedLabel')}
                </Tag>
            );
        case ContractTemplateStatus.NewVersionAvailable:
            return (
                <Tag variant="danger" leadingIcon={IconName.Disable}>
                    {lt('ContractTemplateUnavailableLabel')}
                </Tag>
            );
        default:
            return null;
    }
};
